export const stringifyJSON = (json: object): string => {
  try {
    return JSON.stringify(json);
  } catch (e) {
    return json?.toString();
  }
};
